export const environment = {
  production: false,
  token_label: "__@lr_authadmin",
  api_url: "https://api.lernerandroweapp.com/api/",
  // api_url: "http://localhost:3000/api/",
  googleMapsApiKey: "AIzaSyDZa7LbC-PhB6qDBiho5a_4IoG3Vc038HY",
};
